import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, Form, FormGroup, Input, Row } from "reactstrap";
import { MessageResultState } from "../../../../types/general-types";
import { inject, observer } from "mobx-react";
import LoginStore from "./store";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import Button from "../../../../components/Button";
import { BiLogIn } from "react-icons/bi";
import { setSessionKey, setUser } from "../../../../utils/SsoSession";
import { Controller, useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import LanguageSelection from "../../../../components/Layout/partials/Header/parts/languageSelection";
import AccountActionStore from "./store";
import {
  ChangePasswordRequestDto,
  SendChangePasswordLinkResponseDto,
  SendChangePasswordVerificationCodeResponseDto,
} from "./types";
import ChangePasswordVerifyModal from "./change-password-verify-modal";
import cx from "classnames";

interface IPage {
  AccountActionStore?: AccountActionStore;
}
const LoginPage: FC<IPage> = inject("AccountActionStore")(
  observer((props: IPage) => {
    const { AccountActionStore: store } = props;
    const { t, i18n } = useTranslation();
    const [animationShow, setAnimationShow] = useState<boolean>(false);
    const [muted, setMuted] = useState<boolean>(false);
    const recaptchaRef = useRef<ReCAPTCHA>(null); // reCAPTCHA referansı

    const [verificationCodeResponseData, setVerificationCodeResponseData] =
      useState<SendChangePasswordVerificationCodeResponseDto>();
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);

    const rules = useMemo(
      () => [
        {
          label: "Must be at least 14 characters long.",
          test: (pw: string) => {
            console.log("pw:", pw);
            return pw.length >= 14;
          },
        },
        {
          label: "Must contain at least 1 digit.",
          test: (pw: string) => /[0-9]/.test(pw),
        },
        {
          label: "Must contain at least 1 special character (like .,!?-)",
          test: (pw: string) => /[.,!?@#$%^&*()\-_+=]/.test(pw),
        },
        {
          label:
            "Must contain at least 1 uppercase and at least 1 lowercase letter.",
          test: (pw: string) => /[a-z]/.test(pw) && /[A-Z]/.test(pw),
        },
      ],
      []
    );
    const queryParams =
      new URLSearchParams(window.location.search).get("q") ?? "";

    // URL'den 'q' parametresini temizle
    useEffect(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }, []);

    const {
      control,
      handleSubmit,
      errors,
      formState,
      watch,
      setValue,
      getValues,
      register,
    } = useForm<ChangePasswordRequestDto>({
      defaultValues: {
        password: "",
        passwordVerify: "",
        key: queryParams,
      },
    });

    register("key", {
      required: t("*Please fill out this field."),
    });
    const password = watch("password");
    console.log("Query Params:", queryParams); // console log olarak kontrol et

    useEffect(() => {
      let videoElement: HTMLVideoElement | null =
        document.querySelector("#video_1");
      if (videoElement) {
        setMuted(false);
        setMuted(true);
      }
    }, []);

    const animation = useMemo(() => {
      return (
        <>
          <div className="h-100 bg-plum-plate bg-animation">
            <video
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                objectFit: "cover",
                top: 0,
                left: 0,
                zIndex: animationShow ? -1 : -2,
              }}
              src="https://strsecuritasdigicloud.blob.core.windows.net/upload-1324d8f0-8e85-49cf-8aa2-46b1f147/ui_videos/login_2.mp4"
              controls={false}
              id={"video_2"}
              muted={muted}
            />

            <video
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                objectFit: "cover",
                top: 0,
                left: 0,
                zIndex: animationShow ? -2 : -1,
              }}
              src="https://strsecuritasdigicloud.blob.core.windows.net/upload-1324d8f0-8e85-49cf-8aa2-46b1f147/ui_videos/login_1.mp4"
              controls={false}
              autoPlay={true}
              muted={muted}
              loop={true}
              id={"video_1"}
            />
            <div className="d-flex h-100 justify-content-center align-items-center mt-5 content">
              <Col
                md="4"
                className="mx-auto app-login-box p-3 mt-5"
                style={{ backgroundColor: "white", borderRadius: 10 }}
              >
                <div className=" mx-auto mb-3" />

                <div className="modal-dialog w-100 mx-auto">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="h5 modal-title text-center mb-4">
                        <h4 className="mt-2">
                          <span>{t("Please enter your new password.")}</span>
                        </h4>
                      </div>
                      <div>
                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <Controller
                                name={"password"}
                                control={control}
                                rules={{
                                  required: t("*Please fill out this field."),
                                  maxLength: {
                                    value: 100,
                                    message: t(
                                      "The given value should be smaller than {{ value }}.",
                                      { value: 100 }
                                    ),
                                  },
                                }}
                                render={(field) => (
                                  <input
                                    {...field}
                                    id={"password"}
                                    className="form-control"
                                    placeholder={t("Password")}
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                )}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={12}>
                            <FormGroup>
                              <Controller
                                name={"passwordVerify"}
                                control={control}
                                rules={{
                                  required: t("*Please fill out this field."),
                                  maxLength: {
                                    value: 100,
                                    message: t(
                                      "The given value should be smaller than {{ value }}.",
                                      { value: 100 }
                                    ),
                                  },
                                }}
                                render={(field) => (
                                  <input
                                    {...field}
                                    id={"passwordVerify"}
                                    className="form-control"
                                    placeholder={t("Verify new password")}
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                )}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={12} className="mt-3">
                            <FormGroup>
                              <span
                                className="text-primary ps-2"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                {t(
                                  "Your password must be determined in accordance with the conditions below."
                                )}
                              </span>
                              <ul className="mt-2">
                                {rules.map((rule, index) => {
                                  const isValid = rule.test(password);
                                  return (
                                    <li
                                      key={index}
                                      className={cx("", {
                                        "text-success": isValid,
                                        "text-danger": !isValid,
                                      })}
                                    >
                                      {t(rule.label)}
                                    </li>
                                  );
                                })}
                                <li key={4}>
                                  {t(
                                    "Your password must be different from your last 2 passwords."
                                  )}
                                </li>
                              </ul>
                            </FormGroup>
                          </Col>

                          <div className="divider" />

                          <Col md={12}>
                            <FormGroup className="recaptcha-container">
                              <div className="modal-footer clearfix">
                                <div className="float-right">
                                  <Button
                                    text={t("Save")}
                                    className="btn btn-primary"
                                    onClick={async () => {
                                      if (!getValues("key")) {
                                        toast.error(
                                          t(
                                            "Incorrect session key. Please change your password via the email sent to you."
                                          )
                                        );
                                        return;
                                      }

                                      var isValid = true;
                                      rules.forEach((rule, index) => {
                                        if (!rule.test(password))
                                          isValid = false;
                                      });
                                      if (!isValid) {
                                        toast.error(
                                          t(
                                            "Password must meet all conditions."
                                          )
                                        );
                                      } else if (
                                        getValues("password") !==
                                        getValues("passwordVerify")
                                      ) {
                                        toast.error(
                                          t("The passwords are not the same.")
                                        );
                                      } else if (store)
                                        await store
                                          .SendChangePasswordVerificationCode(
                                            getValues()
                                          )
                                          .then((response) => {
                                            if (
                                              response.state ===
                                              MessageResultState.SUCCESS
                                            ) {
                                              setVerificationCodeResponseData(
                                                response.result
                                              );
                                              toggleModal();
                                            }
                                          });
                                    }}
                                    // type="submit"
                                  ></Button>
                                </div>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center opacity-8 mt-3">
                  Copyright &copy; Securitas
                </div>
              </Col>
            </div>
          </div>
          {modal && verificationCodeResponseData && (
            <ChangePasswordVerifyModal
              AccountActionStore={store}
              verificationCodeResponseData={verificationCodeResponseData}
              changePasswordRequestData={getValues()}
              isShow={modal}
              toggleModal={toggleModal}
            />
          )}
          {/* <ToastContainer /> */}
        </>
      );
    }, [
      animationShow,
      muted,
      t,
      control,
      rules,
      modal,
      verificationCodeResponseData,
      store,
      getValues,
      toggleModal,
      password,
    ]);

    return <div>{animation}</div>;
  })
);

export default LoginPage;
